import { type ReactNode } from 'react'

/**
 * Einheitliches Layout für die statischen Rechtsseiten (Impressum,
 * Datenschutz, Nutzungsbedingungen). Bewusst schlicht und gut lesbar.
 */
export function LegalPage({
	title,
	updated,
	children,
}: {
	title: string
	updated?: string
	children: ReactNode
}) {
	return (
		<main className="mx-auto w-full max-w-3xl flex-1 px-4 py-12 sm:px-8">
			<h1 className="font-display text-[34px] font-semibold tracking-[-0.01em]">
				{title}
			</h1>
			{updated ? (
				<p className="text-muted-foreground mt-1 text-sm">Stand: {updated}</p>
			) : null}
			<div className="[&_h2]:font-display [&_p]:text-body-md mt-8 flex flex-col gap-6 text-[15px] leading-relaxed [&_a]:underline [&_a]:underline-offset-2 [&_h2]:mt-2 [&_h2]:text-xl [&_h2]:font-semibold [&_h3]:font-medium [&_ul]:list-disc [&_ul]:pl-6">
				{children}
			</div>
		</main>
	)
}
